import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ScrollArea from "react-scrollbar";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { KeolisSpinner,moment } from './common/commonExport';
import { eAndDActivitiesAction } from '../actions/index';

class EandDActivies extends React.Component {

  componentDidMount() {
    this.getData();
  }

  // get data for component
  getData() {
    let workday = this.props.workday ? this.props.workday.workday : '' ;
    if(workday){
    let workdayDate = moment(workday.wdy_date, 'MM/DD/YYYY')
     workdayDate = workdayDate.format('YYYYMMDD');
      let fetchObj = {
        id : workday.demp_display_id,
        date: workdayDate
    }
    this.props.eAndDActivitiesAction(fetchObj);
    }  
};


  render() {
    return (
      <div className="EnDTable">
        <Table className="mainTblHead table-striped table-bordered table-condensed">
          <Thead>
            <Tr>
              <Th className="EnDactivities width20">Lbr</Th>
              <Th className="EnDactivities width20">Job</Th>
              <Th className="EnDactivities width20">Hours</Th>
              <Th className="EnDactivities width20">Dollars</Th>
              <Th className="EnDactivities width20">Rate</Th>
            </Tr>
          </Thead>
        </Table>
        <ScrollArea
          ref={el => { this.scrollContainer = el }}
          speed={0.8}
          className="scroll-bar"
          contentClassName="content"
          horizontal={false}
        >
          <Table className="table table-striped  table-condensed">
            <Tbody>
              {this.renderEnDActivities()}
            </Tbody>
          </Table>
        </ScrollArea>
        {this.showTotal()}
      </div>
    )
  }

  renderEnDActivities() {
    let eAndDActivities = this.props.workday.eAndDActivities;
    if (this.props.isLoading) {
      return (
        <Tr>
          <Td>
            <KeolisSpinner />
          </Td>
        </Tr>
      )
    } else if (eAndDActivities && eAndDActivities.length > 0) {
      let activities = eAndDActivities.map((activity, index) => {
        return <Tr key={index}>
          <Td className="width20">{activity.LbrCat}</Td>
          <Td className="width21">{activity.JobCode}</Td>
          <Td className="width20">{activity.Hours}</Td>
          <Td className="width20">{`$${activity.wageamount}`}</Td>
          <Td className="width20">{activity.HOURLYRATE}</Td>
        </Tr>
      })
      return activities;
    } else {
      return <Tr>
        <Td colSpan="100%">
          No records available...
        </Td>
      </Tr>
    }
  }

  showTotal(){
    let eAndDActivities = this.props.workday.eAndDActivities;
    let total = 0;
    if (eAndDActivities && eAndDActivities.length > 0) {
      eAndDActivities.map((activity, index) => {
         total = total + activity.wageamount;
      })
      return <div className="eAndDTotal">Total: ${total.toFixed(2)}</div>;
    }
  }

}

function mapStateToProps(state) {
  return {
    workday: state.workday,
    isLoading: state.workdays.isLoading,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      eAndDActivitiesAction: eAndDActivitiesAction
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(EandDActivies);
